import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../components/Head'
import { useSpring, animated } from 'react-spring';
import { useState } from 'react';
import  * as common from '../common/commonFunction'

const Aboutus = () => {

    const [state, toggle] = useState(true)
    const { x } = useSpring({ from: { x: 0 }, x: state ? 1 : 0, config: { duration: 2000 } })

    return (
        <>
            <Head />
            <Header />
            <div className="container" style={{ width: "100%" }} onClick={()=>common.focusOutMenu()}>
                <content>
                    <div className="input-form" style={{ textAlign: "center" }} data-aos="zoom-in">
                        <div class="aboutus-img" style={{padding:"0 15pt"}}>
                            <img src="/img/aboutus.png" className="w-100"></img>
                        </div> 
                    </div>
                </content>
            </div >
            <Footer />
        </>
    )
}
export default Aboutus;